import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router';

function ItemDetails() {
  const { id } = useParams();
  const [itemDetails, setItemDetails] = useState(null);
  const [itemError, setItemError] = useState(null);

  useEffect(() => {
    const fetchItem = async () => {
      setItemError(null);
      setItemDetails(null);
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}item/${id}`);
        if (!response.ok) throw new Error('Item not found');
        const data = await response.json();
        setItemDetails(data);
      } catch (err) {
        setItemError(err.message || 'Failed to fetch item');
      }
    };
    fetchItem();
  }, [id]);

  return (
    <div>
      <h3>Item Details for {id}</h3>
      {itemError && <div style={{ color: 'salmon', marginTop: 10 }}>{itemError}</div>}
      {itemDetails && (
        <pre style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>{JSON.stringify(itemDetails, null, 2)}</pre>
      )}
    </div>
  );
}

export default ItemDetails;
